import axios from '@/api/axios'
export default {
  login (credential) {
    return axios.post('/login', { email: credential.email, password: credential.password })
  },
  refresh () {
    return axios.get('/refresh')
  },
  getCurrentUser () {
    return axios.get('/account/profile')
  },
}
